import { Box, Chip } from '@mui/material'
import type { FC } from 'react'

type MaterialChipsProps = {
  readonly materials: readonly string[]
  readonly className?: string
}

const chipSx = {
  fontSize: '0.72rem',
  letterSpacing: '0.04em',
  height: 26,
  borderColor: 'rgba(255, 255, 255, 0.14)',
  color: 'text.secondary',
  backgroundColor: 'rgba(255, 255, 255, 0.04)',
  '& .MuiChip-label': { px: 1.1 }
} as const

const MaterialChips: FC<MaterialChipsProps> = ({ materials, className = '' }) => {
  if (materials.length === 0) return null

  return (
    <Box
      className={`material-chips ${className}`.trim()}
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}
      aria-label='Materials'
    >
      {materials.map((material) => (
        <Chip
          key={material}
          label={material.toLowerCase()}
          size='small'
          variant='outlined'
          sx={chipSx}
        />
      ))}
    </Box>
  )
}

export default MaterialChips
